import styled from '@emotion/styled';
import { Button as MuiButton } from '@mui/material';

import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import logo from '@/images/did_logo.svg';
import { useAuth } from '@/services/auth';
import { isMobile } from '@/utils/utils';

const Container = styled.div`
    background: radial-gradient(50% 50% at 0% 110%, #c971ff -80%, rgba(201, 113, 255, 0) 100%),
        radial-gradient(50% 50% at 120% 10%, #5c79fc -80%, rgba(92, 121, 252, 0) 100%), #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
`;

const Logo = styled.div``;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

const Card = styled.div<{ mobile: boolean }>`
    border-radius: ${({ mobile }) => (mobile ? 'none' : '12px')};
    background: #fff;
    box-shadow: 0px 12px 40px 0px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: ${({ mobile }) => (mobile ? '100%' : '405px')};
    height: ${({ mobile }) => (mobile ? '100%' : '365px')};
    padding: 40px;
`;

const Title = styled.h1`
    margin: 23px 0 9px;
    font-weight: 500;
`;

const Subtitle = styled.span`
    font-weight: 400;
    font-size: 1.2rem;
    padding: 0 20px;
`;

const Button = styled(MuiButton)`
    background: #5c79fc;
    border-radius: 12px;
    color: #fff !important;
    height: 54px;
    font-size: 1.3rem;
    text-transform: none;

    &:hover {
        background-color: #5d5fef;
    }
`;

const PARAMS_TO_REMOVE = ['error_description', 'error', 'account_merged'];
const cleanRedirectUri = (redirectUri: string) => {
    const url = new URL(redirectUri);
    PARAMS_TO_REMOVE.forEach(param => url.searchParams.delete(param));
    return url.toString();
};

interface Props {
    redirectUri?: string;
}

export default function AccountMerged({ redirectUri }: Props) {
    const { loginWithRedirect } = useAuth();
    const mobileView = isMobile();

    const renderCard = () => {
        return (
            <Card mobile={mobileView}>
                <Content>
                    <Logo>
                        <MaskedIcon src={logo} size="6rem" color="#000000" />
                    </Logo>
                    <Title>Looks like you have two accounts using the same email</Title>
                    <Subtitle>We've gone ahead and merged them. Please log in again</Subtitle>
                </Content>
                <Button
                    size="large"
                    fullWidth
                    onClick={() =>
                        loginWithRedirect({
                            prompt: 'login',
                            ...(redirectUri && { redirectUri: cleanRedirectUri(redirectUri) }),
                        })
                    }>
                    Log in
                </Button>
            </Card>
        );
    };

    if (mobileView) {
        return renderCard();
    }

    return <Container>{renderCard()}</Container>;
}
